<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.65"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path
      v-if="name === 'spark'"
      d="M12 3l2.4 6.6L21 12l-6.6 2.4L12 21l-2.4-6.6L3 12l6.6-2.4L12 3zM20 2v4m-2-2h4"
    />
    <g v-else-if="name === 'settings'"><path d="m10 3-.6 2.1-2 .9-2-.6-2 3.4L5 10.4v2.2l-1.6 1.6 2 3.4 2-.6 2 .9L10 20h4l.6-2.1 2-.9 2 .6 2-3.4-1.6-1.6v-2.2l1.6-1.6-2-3.4-2 .6-2-.9L14 3z" /><circle cx="12" cy="11.5" r="3" /></g>
    <path v-else-if="name === 'gauge'" d="M5 19a9 9 0 1 1 14 0H5zm7-6 4-5M6 12h1m10 0h1m-6-6v1" />
    <path v-else-if="name === 'refresh'" d="M20 5v5h-5M19.2 10a7.5 7.5 0 1 0 .2 4" />
    <path v-else-if="name === 'arrow-down'" d="M12 4v16m-7-7 7 7 7-7" />
    <g v-else-if="name === 'info'"><circle cx="12" cy="12" r="9" /><path d="M12 7v6m0 4h.01" /></g>
    <path v-else-if="name === 'copy'" d="M9 8h10v13H9zM15 8V3H4v13h5" />
    <path v-else-if="name === 'close'" d="m6 6 12 12M18 6 6 18" />
    <path v-else-if="name === 'check'" d="m5 12 4 4L19 6" />
    <path v-else-if="name === 'bulb'" d="M9 18h6m-5 3h4M8 14a6 6 0 1 1 8 0l-1 2H9l-1-2z" />
    <path v-else-if="name === 'back'" d="M14 5l-7 7 7 7" />
    <path v-else-if="name === 'plus'" d="M12 5v14M5 12h14" />
    <path v-else-if="name === 'send'" d="M12 19V5m-6 6 6-6 6 6" />
    <path v-else-if="name === 'history'" d="M4 7a9 9 0 1 1-1 7M4 2v5h5m3 0v5l3 2" />
    <path v-else-if="name === 'like'" d="M8 20H4V10h4m0 10h10l2-10h-7l1-6-2-1-4 7v10z" />
    <path v-else-if="name === 'dislike'" d="M8 4H4v10h4M8 4h10l2 10h-7l1 6-2 1-4-7V4z" />
    <path v-else-if="name === 'shield'" d="M12 3l8 3v6c0 5-8 9-8 9s-8-4-8-9V6l8-3zm-4 9 3 3 5-6" />
    <path v-else-if="name === 'search'" d="M21 21l-5-5m2-6a7 7 0 1 1-14 0 7 7 0 0 1 14 0z" />
    <path v-else d="M9 3h6v8H9V3zm-3 7v2a6 6 0 0 0 12 0v-2m-6 8v3m-4 0h8" />
  </svg>
</template>
<script>
export default { props: { name: { type: String, default: 'spark' } } }
</script>
<style scoped>
svg {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  vertical-align: middle;
}
</style>
